import React from "react";

import { isZh } from "../../utils/language";

export default function PreRegHeaderCard({
  registrarType,
  formConfig,
  lunarInfo,
}) {

  const cfg =
    formConfig?.preRegCustomFields || {};

  const title =
    isZh()
      ? (
        cfg.titleZh ||
        cfg.titleId
      )
      : (
        cfg.titleId ||
        cfg.titleZh
      );

  const description =
    isZh()
      ? (
        cfg.descZh ||
        cfg.descId
      )
      : (
        cfg.descId ||
        cfg.descZh
      );

  const instruction =
    isZh()
      ? (
        cfg.instructionZh ||
        cfg.instructionId
      )
      : (
        cfg.instructionId ||
        cfg.instructionZh
      );

  const scope =
    cfg.formScope ||
    "internal_external";

  return (
    <div className={`left-panel ${registrarType}`}>

      <div className="panel-type">

        {registrarType === "internal"
          ? "INTERNAL"
          : registrarType === "external"
            ? "EXTERNAL"
            : "PUBLIC"}

      </div>

      <div className="panel-title">
        {title}
      </div>

      {description && (
        <div className="panel-desc">
          {description}
        </div>
      )}

      {cfg.agendaDate && (
        <div className="panel-date-wrap">
          <div className="panel-date">
            {cfg.agendaDate}
          </div>
          {lunarInfo && (
            <div className="panel-lunar-date">

              歲次
              {lunarInfo.lunarGanZhi}
              {" "}

              {lunarInfo.leapMonth
                ? "閏"
                : ""}

              {lunarInfo.lunarMonth}月
              {lunarInfo.lunarDay}日
            </div>
          )}
        </div>
      )}

      <div className="scope-badge">

        {scope === "internal" &&
          (
            isZh()
              ? "僅限內部"
              : "Internal Only"
          )}

        {scope === "internal_external" &&
          (
            isZh()
              ? "內部 + 外部"
              : "Internal + External"
          )}

        {scope === "internal_public" &&
          (
            isZh()
              ? "內部 + 公開"
              : "Internal + Public"
          )}

      </div>

      {instruction && (
        <div className="instruction-box">
          {instruction}
        </div>
      )}

      <style>{`

        .left-panel{
          padding:1.2rem;
          border-radius:1rem;
          border:1px solid #dbe3ef;
        }

        .left-panel.internal{
          background:#eef8ef;
        }

        .left-panel.external{
          background:#f4f5fb;
        }

        .left-panel.public{
          background:#faf6ff;
        }

        .panel-type{
          font-size:0.75rem;
          font-weight:700;
          color:#64748b;
          letter-spacing:0.08rem;
        }

        .panel-title{
          margin-top:0.5rem;
          font-size:1.4rem;
          font-weight:700;
          line-height:1.4;
        }

        .panel-desc{
          margin-top:0.7rem;
          font-size:0.92rem;
          color:#475569;
          line-height:1.7;
        }

        .panel-date-wrap{
          margin-top:1rem;
        }

        .panel-date{
          font-size:0.95rem;
          font-weight:700;
        }

        .panel-lunar-date{
          margin-top:0.2rem;
          font-size:0.82rem;
          color:#64748b;
        }

        .scope-badge{
          margin-top:1rem;
          display:inline-flex;
          padding:0.45rem 0.8rem;
          border-radius:999rem;
          background:#dbeafe;
          color:#1d4ed8;
          font-size:0.78rem;
          font-weight:700;
        }

        .instruction-box{
          margin-top:1.2rem;
          padding:1rem;
          border-radius:0.8rem;
          background:#fff;
          border:1px solid #dbe3ef;
          font-size:0.85rem;
          line-height:1.7;
          white-space:pre-wrap;
        }

      `}</style>

    </div>
  );
}